let Constants = {
    install(Vue, options) {
        Vue.Constants = {
            STACKING_THRESHOLD: 10,
            PATH_FILTER_NAME: 'Path',
            PATH_ENUM_FILTER_NAME: 'PathSingle',
        };
    }
};

export default Constants;